import { useMutation } from '@tanstack/react-query';
import type AgentApiAiJobSearchPersonasItem from '@/types/serializers/AgentApiAiJobSearchPersonasItem';
import type SharedAiSourceSelection from '@/types/serializers/SharedAiSourceSelection';

type CreatePersonaRequest = {
  /** 入力タイプ: candidate / uploaded_file / free_text */
  input_type: string;
  candidate_profile_id?: number;
  free_text?: string;
  /** 参照するデータソースのカテゴリ（例: ['basic_info', 'custom_data', 'document']） */
  selected_sources?: string[];
  /** カテゴリ内の個別ID選択（決定1: custom_data / candidate_interview_log の絞り込み） */
  source_selection?: Partial<SharedAiSourceSelection>;
  uploaded_file_signed_ids?: string[];
};

/** AI求人検索ペルソナを新規作成するミューテーション */
export default function useCreateAiJobSearchPersona() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (request: CreatePersonaRequest): Promise<AgentApiAiJobSearchPersonasItem> => {
      const response = await fetch('/agent/api/ai_job_search_personas', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(request),
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        const message =
          typeof errorBody?.message === 'string'
            ? errorBody.message
            : 'ペルソナの作成に失敗しました';
        throw new Error(message);
      }

      const data: AgentApiAiJobSearchPersonasItem = await response.json();
      return data;
    },
  });
}
